import { useState } from 'react';
import {
  Group,
  Header,
  Button,
  SimpleCell,
  Text,
  Snackbar,
} from '@vkontakte/vkui';
import { useNavigate } from 'react-router-dom';
import { OnboardingPage } from '../OnboardingPage';
import { AuthGatePage } from '../AuthGatePage';
import { LoginPage } from '../LoginPage';
import { FlowPreviewBanner } from '../../components/FlowPreviewBanner';

type FlowStep = 'menu' | 'onboarding' | 'gate' | 'login';

export function AdminUserFlow() {
  const navigate = useNavigate();
  const [step, setStep] = useState<FlowStep>('menu');
  const [snack, setSnack] = useState<string | null>(null);

  const exitToMenu = () => setStep('menu');

  if (step === 'onboarding') {
    return (
      <OnboardingPage
        previewMode
        onExitPreview={exitToMenu}
        onComplete={() => setStep('gate')}
      />
    );
  }

  if (step === 'gate') {
    return (
      <AuthGatePage
        previewMode
        onExitPreview={exitToMenu}
        onLoginClick={() => setStep('login')}
      />
    );
  }

  if (step === 'login') {
    return (
      <LoginPage
        previewMode
        onExitPreview={exitToMenu}
        onBackClick={() => setStep('gate')}
        onLoginSuccess={() => {
          setSnack('Вход выполнен — проверка API прошла успешно.');
          setStep('menu');
        }}
      />
    );
  }

  return (
    <>
      <Group header={<Header size="s">Проверка пути участника</Header>}>
        <SimpleCell multiline>
          <Text className="pb-text-secondary" style={{ fontSize: 14 }}>
            Пройдите те же экраны, что видит участник при первом входе: онбординг →
            регистрация/вход → форма ID Первых и email. Удобно для проверки после
            деплоя и правок UI.
          </Text>
        </SimpleCell>
      </Group>

      <Group header={<Header size="s">Полный путь</Header>}>
        <div style={{ padding: '0 16px 8px' }}>
          <Button
            size="l"
            stretched
            className="pb-gradient-btn"
            onClick={() => setStep('onboarding')}
          >
            С начала (как новый пользователь)
          </Button>
          <Text
            className="pb-text-secondary"
            style={{ fontSize: 13, marginTop: 8, display: 'block' }}
          >
            Онбординг → регистрация/вход → форма ID и email
          </Text>
        </div>
      </Group>

      <Group header={<Header size="s">Отдельные экраны</Header>}>
        <SimpleCell subtitle="Галерея приветствия" onClick={() => setStep('onboarding')}>
          Онбординг
        </SimpleCell>
        <SimpleCell
          subtitle="Кнопки регистрации на сайте и входа"
          onClick={() => setStep('gate')}
        >
          Экран после онбординга
        </SimpleCell>
        <SimpleCell
          subtitle="ID Первых + email (реальный запрос к API)"
          onClick={() => setStep('login')}
        >
          Форма входа
        </SimpleCell>
        <SimpleCell
          subtitle="Демо-данные участника с лицензией"
          onClick={() => navigate('/profile')}
        >
          Демо-профиль участника
        </SimpleCell>
      </Group>

      <Group>
        <div style={{ padding: '0 16px 16px' }}>
          <FlowPreviewBanner />
        </div>
      </Group>

      {snack && <Snackbar onClose={() => setSnack(null)}>{snack}</Snackbar>}
    </>
  );
}
